var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.646,14.291A1.646,1.646,0,1,0,5,12.646,1.648,1.648,0,0,0,6.646,14.291Zm0-2.194a.549.549,0,1,1-.549.549A.549.549,0,0,1,6.646,12.1Z",
    transform: "translate(-2.806 -8.806)",
    fill: "#00848d",
    stroke: "#00848d",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.646,14.291A1.646,1.646,0,1,0,13,12.646,1.648,1.648,0,0,0,14.646,14.291Zm0-2.194a.549.549,0,1,1-.549.549A.549.549,0,0,1,14.646,12.1Z",
    transform: "translate(-5.884 -8.806)",
    fill: "#00848d",
    stroke: "#00848d",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.646,14.291A1.646,1.646,0,1,0,21,12.646,1.648,1.648,0,0,0,22.646,14.291Zm0-2.194a.549.549,0,1,1-.549.549A.549.549,0,0,1,22.646,12.1Z",
    transform: "translate(-9.14 -8.806)",
    fill: "#00848d",
    stroke: "#00848d",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.734,7H2.766A1.879,1.879,0,0,0,1,8.97V37.863a1.879,1.879,0,0,0,1.766,1.97H35.734a1.879,1.879,0,0,0,1.766-1.97V8.97A1.879,1.879,0,0,0,35.734,7ZM2.766,8.313H35.734a.626.626,0,0,1,.589.657v5.91H2.177V8.97A.626.626,0,0,1,2.766,8.313Zm-.589,29.55V16.193h4.71v1.313H4.532V18.82H6.887v1.313H3.355v1.313H6.887V22.76H4.532v1.313H6.887v1.313H3.355V26.7H6.887v1.313H4.532v1.313H6.887V30.64H3.355v1.313H6.887v1.313H4.532V34.58H6.887v1.313H3.355v1.313H6.887V38.52H2.766A.626.626,0,0,1,2.177,37.863Zm14.129.657H11.6V31.953h4.71Zm8.242,0h-4.71V26.7h4.71Zm8.242,0h-4.71V20.133h4.71Zm2.944,0H33.968V18.82H26.9v19.7H25.726V25.387H18.661V38.52H17.484V30.64H10.419v7.88H8.065V16.193H36.323v21.67A.626.626,0,0,1,35.734,38.52Z",
    transform: "translate(-1 -7)",
    fill: "#00848d",
    stroke: "#00848d",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,25v1.1h9.043l2.579,3.61.892-.637L24.608,25Z",
    transform: "translate(-6.431 -12.777)",
    fill: "#00848d",
    stroke: "#00848d",
    strokeWidth: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingsIcon);
export default __webpack_public_path__ + "static/media/ratings-icon.43e4f1fd56f5cc3ca1cd9803450d7906.svg";
export { ForwardRef as ReactComponent };